// src/services/userService.ts
import api from './axios';

export const getAdmin = async () => {
  try {
    const response = await api.get('/admin/me');
    if(response.status === 200){
      return { success: true, message: 'Admin data fetched successfully', data: response.data.data };
    }
    return { success: false, message: 'Failed to fetch admin data', error: response.data.message };
  } catch (error) {
    throw error;
  }
};

export const updateAdmin = async (userData: any) => {
  try {
    const response = await api.put('/admin/edit-profile', userData);
    if(response.status === 200){
      return { success: true, message: 'Admin data updated successfully', data: response.data.data };
    }
    return { success: false, message: 'Failed to update user data', error: response.data.message };
  } catch (error) {
    throw error;
  }
};

export const updateAdminPassword = async (passwordData: any) => {
  try {
    const response = await api.put('/admin/change-password', passwordData);
    if(response.status === 200){
      return { success: true, message: 'Password updated successfully' };
    }
    return { success: false, message: 'Failed to update password', error: response.data.message };
  } catch (error) {
    throw error;
  }
};


export const getUserList = async (page: number, limit: number, query: string, status: string, sortDirection: string) => {
  try {
    const response = await api.get('/admin/user-list', { params: { page, limit, q: query, status, sortDirection } });
    if(response.status === 200){
      return { success: true, message: 'User list fetched successfully', data: response.data.data, pagination: response.data.pagination };
    }
    return { success: false, message: 'Failed to fetch user list', error: response.data.message };
  } catch (error) {
    throw error;
  }
};

export const getUserDetail = async (userId: string) => {
  try {
    const response = await api.get(`/admin/user/${userId}`);
    if(response.status === 200){
      return { success: true, message: 'User detail fetched successfully', data: response.data.data };
    }
    return { success: false, message: 'Failed to fetch user detail', error: response.data.message };
  } catch (error) {
    throw error;
  }
};

export const updateUserStatus = async (userId: string, status: string) => {
  try {
    const response = await api.put(`/admin/user/${userId}/status`, { status });
    if(response.status === 200){
      return { success: true, message: 'User status updated successfully' };
    }
    return { success: false, message: 'Failed to update user status', error: response.data.message };
  } catch (error) {
    throw error;
  }
};